import { BaseLayout } from '@components/buzzkuri/shared/layouts/Base'
import { InitProgramNavList } from '@context/ProgramNavList/InitProgramNavList'
import { StaticPagesRes } from '@type/buzzkuri/static-page'
import { Prices } from './Prices.page'

type Props = StaticPagesRes

export const PricesPage = ({ business, pageContent }: Props): JSX.Element => {
  const { totalProgramCount, programCategories } = pageContent
  InitProgramNavList({ totalProgramCount, programCategories })

  return (
    <BaseLayout {...{ business }}>
      <Prices />
    </BaseLayout>
  )
}
